import { TooltipOption } from "echarts/types/dist/shared";
import { EvaChartStates } from "types/factory";

import { createMpcCompatibleTooltipOptions } from "./mpcTooltip";

export function translateRateCumResponseTooltipOptions(
  states: EvaChartStates
): TooltipOption {
  return createMpcCompatibleTooltipOptions(states);
}
